export default "__VITE_ASSET__DUPUiIwU__"